__turbopack_context__.v({
  "article": "R8Uisa_article",
  "author": "R8Uisa_author",
  "background": "R8Uisa_background",
  "buttonInner": "R8Uisa_buttonInner",
  "buttonMain": "R8Uisa_buttonMain",
  "container": "R8Uisa_container",
  "date": "R8Uisa_date",
  "hasLink": "R8Uisa_hasLink",
  "hasNoLabel": "R8Uisa_hasNoLabel",
  "hasOpen": "R8Uisa_hasOpen",
  "hasSubmenu": "R8Uisa_hasSubmenu",
  "iconCaret": "R8Uisa_iconCaret",
  "iconImage": "R8Uisa_iconImage",
  "iconWrap": "R8Uisa_iconWrap",
  "isOpen": "R8Uisa_isOpen",
  "itemFlyIn": "R8Uisa_itemFlyIn",
  "itemFlyInBackground": "R8Uisa_itemFlyInBackground",
  "itemInner": "R8Uisa_itemInner",
  "itemMain": "R8Uisa_itemMain",
  "label": "R8Uisa_label",
  "menuFlyIn": "R8Uisa_menuFlyIn",
  "menuInner": "R8Uisa_menuInner",
  "menuMain": "R8Uisa_menuMain",
  "set": "R8Uisa_set",
  "size--sm": "R8Uisa_size--sm",
  "size--xs": "R8Uisa_size--xs",
  "slide-down": "R8Uisa_slide-down",
});
